import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

/**
 * Labelled "About" text block rendered inside the expanded identity cards
 * (person bio / company description).
 */
export const AboutSection: FunctionComponent<{
	text?: string | null;
}> = ({ text }) => {
	const { t } = useTranslation();

	if (!text?.trim()) {
		return null;
	}

	return (
		<div className="flex flex-col gap-1.5">
			<div className="text-[10px] font-bold uppercase tracking-wider text-text-tertiary">
				{t("contacts.leadPanel.identity.about")}
			</div>
			<div className="whitespace-pre-line text-xs text-text-secondary">{text}</div>
		</div>
	);
};
